export default __webpack_public_path__ + "static/media/m2_store.5e2711f7.png";